// ============================================
// COSMIC HINDU - Order Service
// ============================================

import api from './api';

const orderService = {
  async getAll(filters = {}) {
    const params = {};
    if (filters.status) params.status = filters.status;
    if (filters.search) params.search = filters.search;
    return api.get('get-orders.php', params);
  },

  async getById(id)          { return api.get('get-orders.php', { id }); },
  async updateStatus(id, status) { return api.post('update-order.php', { id, status }); },
  async create(orderData)    { return api.post('place-order.php', orderData); },
  async getStats()           { return api.get('get-orders.php', { stats: 1 }); },
};

export default orderService;
